import { FC, Fragment, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress, Stack } from "@mui/material";
import { useEffectOnceWhen } from "rooks";
import { OffHoursForm } from "./components/create/OffHoursForm";
import { PageHeader } from "../../common/PageHeader";
import { useGetV2UsersMeOffHoursSchedulesByScheduleIdQuery } from "../../../../services/cloudchipr.api";
import { useAppAbility } from "../../../../services/permissions";

export const OffHoursItem: FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { cannot } = useAppAbility();
  const cannotCreate = cannot("create", "schedule");
  const cannotEdit = cannot("edit", "schedule");
  const disabledForUser = cannotCreate || cannotEdit;

  const { data, isLoading, error, isFetching } =
    useGetV2UsersMeOffHoursSchedulesByScheduleIdQuery(
      { scheduleId: id || "" },
      { skip: !id || disabledForUser },
    );

  const breadcrumbs = useMemo(() => {
    return [
      { title: "Off Hours", to: "/schedule/off-hours" },
      { title: `${id ? "Edit" : "Create new"} Off Hours` },
    ];
  }, [id]);

  const redirect =
    (error && "status" in error && +error.status >= 400) || disabledForUser;

  useEffectOnceWhen(() => {
    navigate("/schedule/off-hours", { replace: true });
  }, redirect);

  return (
    <Fragment>
      <PageHeader breadcrumbs={breadcrumbs} />
      {isLoading || isFetching ? (
        <Stack alignItems="center" pt={4}>
          <CircularProgress />
        </Stack>
      ) : (
        <OffHoursForm schedule={data} />
      )}
    </Fragment>
  );
};
